<script>
import { warehouseService } from '../../../../helpers/backend/warehouse.service';
export default {
  data() {
    return {
      form: {
        id: null,
        name: null,
      },
      busy: false,
      show: true,
      showDismissibleAlert: false,
      error: "",
      active: false,
    };
  },
  created(){
  },
  computed: {
    isUpdateState() {
      return this.form.id != null;
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.busy = true;
      warehouseService.createOrUpdateRegion(this.form).then(
        (data) => {
          if (data != null) {
            this.reset();
            this.$emit("refresh");
            this.showDismissibleAlert = true;
            this.error = "";
            this.setActive(false);
          }
          this.busy = false;
        },
        (error) => {
          this.showDismissibleAlert = true;
          this.error =
            "Failed to Insert/Update Region. Error : " + error;
          this.busy = false;
        }
      );
    },
    reset() {
      // Reset our form values
      this.form.id = null;
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.showDismissibleAlert = false;
      this.error = "";
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onReset(event) {
      event.preventDefault();
      this.setActive(false);
      this.reset();
    },
    setActive(b, outside_triger) {
      this.active = b;
      if (outside_triger) return;
      this.$emit("active_change", b);
    },
    initUpdate(id) {
      this.setActive(true);

      this.$nextTick(() => {
        this.reset();
        this.$refs.name.$el.focus();
        this.busy = true;
        warehouseService.getRegionById(id).then(
          (data) => {
            if (data.region != null) {
              this.form.id = data.region.id;
              this.form.name = data.region.name;
            } else {
              this.showDismissibleAlert = true;
              this.error =
                "Failed to get region to update. Error : region not found";
            }
            this.busy = false;
          },
          (err) => {
            this.showDismissibleAlert = true;
            this.error = "Failed to get region type to update. Error : " + err;
            this.busy = false;
          }
        );
      });
    },
    invokeCreate() {
      this.setActive(true);
    },
    
  },
};
</script>


<template>
  <div v-if="this.active">
    <b-alert
      :variant="error == '' ? 'success' : 'danger'"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert = false"
    >
      <div v-if="error != ''">
        {{ error }}
      </div>
      <div v-else>Success perform Insert/Update action</div>
    </b-alert>
    <div class="card">
      <div class="card-body">
        <div>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show" ref="form">
            <b-overlay :show="busy" rounded="lg" opacity="0.6">
              <b-form-group
                id="input-group-1"
                label="Region Name:"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.name"
                  type="text"
                  placeholder="Region Name"
                  required
                  ref="name"
                ></b-form-input>
              </b-form-group>

              <b-button class="mr-2" type="submit" variant="primary">
                {{ isUpdateState ? "Update" : "Submit" }}
              </b-button>
              <b-button type="reset" variant="danger">Cancel</b-button>
            </b-overlay>
          </b-form>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <b-form-group>
      <b-button variant="primary" @click="invokeCreate">Create new</b-button>
    </b-form-group>
  </div>
</template>



